export const auth = {
    login: `Login`,
    logout: `Logout`,

    username: `Username`,
    password: `Password`,

    login_action: `Login`,
    login_error: `Incorrect username or password`,
}